import './index.less';
import useRouteParams from '@cap/share/src/hooks/useRouteParams';
import classNames from 'classnames';
import { navigatePage } from '@cap/share/src/utils/navigation/index';
import { Menu, Dropdown } from '@ss/mtd-react3';
import React, { useEffect, useMemo, useCallback } from 'react';
import { POT_MENU_BAR } from '@/utils/const';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { selectChannelList, getInitData } from '@/pages/home/homeCourseData';
import { IChannel } from '@/utils/type';

interface AllChannelsProps {
  channelPart: IChannel[];
}
const MenuItem = Menu.Item;
const MAX_VISIBLE_ITEMS = 2; // 展示的频道数

const iframeClick = (url: string) => {
  // 检查 URL 是否以 http:// 或 https:// 开头
  if (!/^https?:\/\//i.test(url)) {
    // 如果不是，则自动加上 http://
    url = `http://${url}`;
  }
  window.open(url, '_blank');
};

const AllChannels: React.FC<AllChannelsProps> = React.memo(({ channelPart }) => {
  const menu = (
    <Menu>
      {channelPart.map((c) => (
        <MenuItem key={String(c.id)} onClick={() => iframeClick(c.iframeUrl ?? '')}>
          {c.tabName}
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <div className="dropdown-demo-trigger-container">
      <Dropdown content={menu} trigger="click">
        更多
      </Dropdown>
    </div>
  );
});

const MenuBar: React.FC = () => {
  const { pathname } = useRouteParams();
  const dispatch = useAppDispatch();
  const channelList = useAppSelector(selectChannelList);
  // 暂时前端手动过滤频道列表-推荐。
  const channelListNoRecommend = channelList.filter((c) => c.tabName !== '推荐');
  const channelPart = useMemo(
    () => channelListNoRecommend?.slice(0, MAX_VISIBLE_ITEMS) || [],
    [channelListNoRecommend],
  );
  const channelAll = useMemo(() => channelListNoRecommend?.slice(MAX_VISIBLE_ITEMS) || [], [channelListNoRecommend]);

  useEffect(() => {
    dispatch(getInitData({ isShowLoading: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onSelect = useCallback((value: string) => {
    if (value) navigatePage(value);
  }, []);

  return (
    <div className="head-tag-container">
      {POT_MENU_BAR.map((c) => (
        <span
          key={c.value}
          onClick={() => onSelect(c.value)}
          className={classNames({ 'head-tag-select-span': c.value === pathname })}
        >
          {c.title}
        </span>
      ))}

      {channelPart.map((c) => (
        <span key={c.id} onClick={() => iframeClick(c.iframeUrl ?? '')}>
          {c.tabName}
        </span>
      ))}

      {channelList?.length > MAX_VISIBLE_ITEMS && <AllChannels channelPart={channelAll} />}
    </div>
  );
};

export default MenuBar;
